import { useQuery } from '@apollo/client/react';
import { Subscription } from '../@types/shared.types';
import { SubscriptionInterval } from '../enums/shared.enums';
import { GET_REACHLINK_PLUS_SUBSCRIPTION } from '../graphql/resolvers/queries';

// TODO: remove once the backend exposes a price field on Subscription.
const PRICE_IN_CENTS_BY_INTERVAL: Record<SubscriptionInterval, number> = {
    [SubscriptionInterval.MONTHLY]: 2500,
    [SubscriptionInterval.YEARLY]: 12000,
};

const useReachlinkPlusSubscription = () => {
    const { data, loading, refetch } = useQuery<{ subscription: Subscription }>(
        GET_REACHLINK_PLUS_SUBSCRIPTION
    );

    const subscription = data?.subscription;
    const isSubscribed = Boolean(subscription?.isActive);
    const priceInCents = subscription
        ? PRICE_IN_CENTS_BY_INTERVAL[subscription.interval]
        : undefined;

    return {
        subscription,
        loading,
        isSubscribed,
        priceInCents,
        refetch,
    };
};

export default useReachlinkPlusSubscription;
